import React from "react"
import PropTypes from "prop-types"
import style from "./TextField.module.css"

const TextField = ({
  name,
  type,
  value,
  emoji,
  // label,
  placeholder,
  onChange,
  onBlur,
  disabled,
  invalid, //Used for highlighting required field if submitted
  valid, //Used for displaying emoji
  // halfWidth,
  customClass,
}) => {
  // const width = halfWidth ? "calc(50% - 16px)" : "100%"

  const width = "100%"

  const showIndicator = valid ? (value ? true : false) : false
  return (
    <>
      <div
        className={[style.container, invalid ? style.invalid : ""].join(" ")}
      >
        {/* Validity Indicator */}
        <span
          style={{
            transform: `translateX(${showIndicator ? 0 : -32}px)`,
            opacity: showIndicator ? 1 : 0,
          }}
          // style={{ opacity: invalid ? 1 : value ? 1 : 0 }}
          className={style.indicator}
          aria-label="input indicator"
          role="img"
        >
          {emoji}
        </span>
        {/* Label */}
        <label
          for={name}
          style={{
            opacity: value ? 0.8 : 1,
            transform: `scale(${value ? 0.8 : 1}) translateY(${
              value ? -40 : 0
            }px) translateX(${value ? -16 : 0}px)`,
          }}
        >
          {placeholder}
        </label>
        {/* Input Field */}
        <input
          name={name}
          type={type}
          // placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className={[style.input, customClass].join(" ")}
          style={{
            width: width,
            transform: `translateX(${showIndicator ? 32 : 0}px)`,
          }}
        />
      </div>
    </>
  )
}

TextField.propTypes = {
  type: PropTypes.string.isRequired,
  // label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  emoji: PropTypes.string.isRequired,
  halfWidth: PropTypes.bool,
  customClass: PropTypes.string,
}

export default TextField
